import { render, staticRenderFns } from "./KiosksItemsTable.vue?vue&type=template&id=00b0b21e"
import script from "./KiosksItemsTable.vue?vue&type=script&lang=js"
export * from "./KiosksItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports